<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
        <div class="p-formgrid p-grid p-col">
          <div class="p-field p-col-12 p-lg-3 p-mt-2">
            <label for="dataGroupOptions">{{ $t("igeneral_dataGroup") }}</label>
            <Dropdown
              v-model="dataGroupSelect"
              :options="dataGroupOptions"
              optionLabel="datagroup_name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="dataGroupOptions">
                <div v-if="dataGroupOptions.value">
                  <div>{{ dataGroupOptions.value.datagroup_name }}</div>
                </div>
                <span v-else>
                  {{ dataGroupOptions.placeholder }}
                </span>
              </template>
              <template #option="dataGroupOptions">
                <div>{{ dataGroupOptions.option.datagroup_name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-12 p-lg-4 p-mt-2" >
            <label for="keyword">{{ $t("keyword") }}</label>
            <InputText id="general_keyword" type="text" v-model="keyword" />
          </div>
          <div class="p-field p-col">
            <div class="p-formgrid p-grid p-jc-end ">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear p-mt-5 p-ml-3 p-mr-3"
              />
              <Button
                @click="searchSystemData()"
                :label="$t('searchBtn')"
                class="p-button-info p-mt-5"
              />
            </div>
          </div>
        </div>
          <div class="p-formgrid p-grid p-col p-mt-1">
                <text-footer
                  :data="Data_text_Footer"
                  :checkShow="text_Footer"
                  :countItem="systemData_table.length.toLocaleString('en-US')"
                />
          </div>

      </div>
    </Fieldset>

    <div class="card p-fluid p-mt-2" >
       <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
       <!--:scrollable="true"  -->
      <DataTable
        :value="columns_disabled?systemData_table:[]"
        
      scrollHeight="500px"
        :paginator="true"
        :rows="10"
        dataKey="id"
        sortField="index"
        :sortOrder="1"
        ref="dt"
        :exportFilename = "`ข้อมูลระบบพื้นฐาน-${date}`"
        :rowHover="true"
        :filters="filters"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
       <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1"  -->
        <template #header>
          <div class="p-grid">
            <div class="table-header p-col-12 p-lg-1" style="padding: 7px;  " id="Create" v-if="checkAdd_data != 'false'">
              <Button
                @click="systemDataModal = true"
                :label="$t('addBtn')"
                class="p-button-success"
              />
              
            </div>

            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;" id="EX"  >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;" id="PDF" >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <!-- Doe PDF เลือกได้  1/5   -->
            <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <span class="p-input-icon-left" v-if="columns_disabled" >   
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="search()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="search()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>

              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>

        <template #empty >{{ $t("TableEmpty") }}</template>

        <div v-if="columns_index == true">  
        <!--Doe : เพิ่มลำดับ 2/4-->
        <Column
          field="index"
          :header="'ลำดับ'"
          :sortable="true"
          :headerStyle="tableColSticky('8rem','center','sticky','top')"
        >
          <template #body="dataTable">  
            <div hidden>{{ dataTable.data.system_id }}</div>
            <div class="table_row">
              {{ dataTable.data.index }}
            </div>
            
          </template>
        </Column>
        </div>
            <div v-else>
                <Column :headerStyle="tableColNone()"></Column>
            </div>
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->

        
        <div v-if="columns_datagroup_name == true"> 
        <Column
          field="datagroup_name"
          :header="$t('igeneral_dataGroup')"
          :sortable="true"
          :headerStyle="tableColSticky('10rem','','sticky','top')"
        >
          <template #body="dataTable">
            <div hidden>{{ dataTable.data.system_id }}</div>
            {{ dataTable.data.datagroup_name }}
          </template>
        </Column>
        </div>
            <div v-else>
                <Column
                headerStyle="width: 0"
                ></Column>
            </div>
        
        <div v-if="columns_system_name == true"> 
        <Column
          field="system_name"
          :header="$t('igeneral_dataName')"
          :sortable="true"
          :headerStyle="tableColSticky('8rem','','sticky','top')"
        >
          <template #body="dataTable">
            {{ dataTable.data.system_name }}
          </template>
        </Column>
        </div>
            <div v-else>
              <Column :headerStyle="tableColNone()"></Column>
            </div>

        <div v-if="columns_maingroup_name == true">   
        <Column
          field="maingroup_name"
          :header="$t('igeneral_dataGroupMain')"
          :sortable="true"
          :headerStyle="tableColSticky('12rem','','sticky','top')"  
        >
          <template #body="dataTable">
            <div v-if="dataTable.data.system_group_id == 'dg-11'">
              {{ $t(`${dataTable.data.maingroup_id}`) }}
            </div>
            <div v-else-if="dataTable.data.maingroup_id != 'null'">
              {{ dataTable.data.maingroup_name }}
            </div>
            <div v-else>-</div>
          </template>
        </Column>
        </div>
            <div v-else>
              <Column :headerStyle="tableColNone()"></Column>
            </div>

        <!-- coloumn ลำดับ -->
        <!-- <Column
          field="system_no"
          :header="$t('igeneral_sequence')"
          :sortable="true"
          headerStyle="width: 10rem"
        >
          <template #body="dataTable">
            <div
              v-if="
                dataTable.data.system_no == 0 || dataTable.data.system_no == ''
              "
            >
              -
            </div>
            <div v-else>{{ dataTable.data.system_no }}</div>
          </template>
        </Column> -->

        <!-- style="border-left: 1px solid #d8d8d8;
                            padding: 21px 14px;
                            background-color: #fff;
                            margin: 0;"  -->

                            <div v-if="columns_date_create == true">
          <Column
            field="date_create_ddmmyy"
            :header="'วันที่สร้างข้อมูล'"
            :sortable="true"
            :headerStyle="tableColSticky('15rem','','sticky','top')"
          >
            <template #body="dataTable">
              <div v-if="columns_date_create == true">
                {{ dataTable.data.date_create_ddmmyy }}
              </div>
            </template>
          </Column>
        </div>
        <div v-else>
          <Column :headerStyle="tableColNone()"></Column>  
        </div>

        <div v-if="columns_date_update == true">
          <Column
            field="date_update_ddmmyy"
            :header="'วันที่ปรับปรุงข้อมูล'"
            :sortable="true"
            :headerStyle="tableColSticky('15rem','','sticky','top')"
          >
            <template #body="dataTable">
              <div v-if="columns_date_update == true">
                {{ dataTable.data.date_update_ddmmyy }}
              </div>
            </template>
          </Column>
        </div>
        <div v-else>
          <Column :headerStyle="tableColNone()"></Column>  
        </div>

      <div v-if="columns_index ||
                 columns_datagroup_name ||  
                 columns_system_name ||
                 columns_maingroup_name||
                 columns_date_create ||
                 columns_date_update ">  
        <Column :header="$t('controlTable')"       
        :headerStyle="table_headerStyle"    
        :bodyStyle="table_bodyStyle" 
        headerClass="column_manege" 
        v-if="checkEdit_data != 'false' || checkDelete_data != 'false' ">
          <template #body="dataTable">
                <div class="p-formgrid col_manege" v-if="checkPermission()" >  
                    <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                      <Button
                        @click="
                          systemDataModal = true;
                          editData(dataTable.data.system_id);
                          temp = dataTable.data.system_id;
                        "
                        icon="pi pi-pencil"
                        :label="table_editBTN"
                        class="p-button-rounded p-button-warning"      
                      />
                    </div>
                    <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                      <Button
                        @click="
                          // displayConfirmation = true;
                          temp = dataTable.data.system_id;
                          alertDisplay(temp);
                        "
                        icon="pi pi-trash"
                        :label="table_deleteBTN"
                        class="p-button-rounded p-button-danger"
                      />
                    </div>
                </div>
                <div v-else >
                  {{"ไม่มีสิทธิ์จัดการข้อมูลนี้"}}
                </div>
          </template>
        </Column>
      </div>
      <div v-else>
                <Column
                headerStyle="width: 0"
                ></Column>
        </div> 

      </DataTable>
    </div>

    <!-- Manage general system modal -->
    <Dialog
      :modal="true"
      :visible.sync="systemDataModal"
      :style="{ width: '850px' }"
      :closable="loadingCreate ? false : true"
      :header="header"
    >
      <div class="confirmation-content">
        <!-- โหลดเพิ่มแก้ไข 1/8-->
        <div class="From_Loading" v-if="loadingCreate" style="top:30%" >
          <ProgressSpinner 
            style="width:120px;
                   height:120px ;
                   color:red" 
            strokeWidth="5"
            animationDuration="1s" />
            <div class="waveTextAnimated">
              <span >กำ</span>
              <span >ลัง</span>
              <span >บัน</span>
              <span >ทึก</span>
              <span >ข้อ</span>
              <span >มูล</span>
              <!-- กำลังบันทึกข้อมูล -->
            </div>
            
        </div>
        <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
        <label>{{ $t("systemData_modal_subtitle") }}</label>
        <div class="p-fluid p-mt-5">
          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col-12 p-lg-6" style="margin-top: -5px">
              <label for="dataGroupOptions"
                >{{ $t("igeneral_dataGroup") }}
                <span class="required-input">*</span></label
              >
              <Dropdown
                v-model="igeneral_dataGroupSelect"
                :options="dataGroupOptions"
                optionLabel="datagroup_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :class="{
                  'p-invalid':
                    error_igeneral_dataGroupSelect && !igeneral_dataGroupSelect,
                }"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="dataGroupOptions">
                  <div v-if="dataGroupOptions.value">
                    <div>{{ dataGroupOptions.value.datagroup_name }}</div>
                  </div>
                  <span v-else>
                    {{ dataGroupOptions.placeholder }}
                  </span>
                </template>
                <template #option="dataGroupOptions">
                  <div>{{ dataGroupOptions.option.datagroup_name }}</div>
                </template>
              </Dropdown>
              <small
                class="p-invalid"
                v-if="
                  error_igeneral_dataGroupSelect && !igeneral_dataGroupSelect
                "
                >{{ $t("igeneral_dataGroup_validate") }}</small
              >
            </div>
            <div class="p-field p-col-9 p-lg-6">
              <label for="dataGroupMainOptions">{{
                $t("igeneral_dataGroupMain")
              }}</label>
              <Dropdown
                :disabled="disabledMaingroup == 1"
                v-model="igeneral_dataGroupMainSelect"
                :options="dataGroupMainOptions"
                optionLabel="system_name"
                :filter="true"
                :placeholder="$t('placeholderSelectBox')"
                :showClear="true"
                :clearFilterDropdown="dropdownClearFilerValue"
              >
                <template #value="dataGroupMainOptions">
                  <div v-if="dataGroupMainOptions.value">
                    <div>{{ dataGroupMainOptions.value.system_name }}</div>
                  </div>
                  <span v-else>
                    {{ dataGroupMainOptions.placeholder }}
                  </span>
                </template>
                <template #option="dataGroupMainOptions">
                  <div>{{ dataGroupMainOptions.option.system_name }}</div>
                </template>
              </Dropdown>
            </div>
            <!-- <div class="p-field p-col-3 p-lg-2">
              <label for="igeneral_sequence">{{
                $t("igeneral_sequence")
              }}</label>
              <InputNumber
                id="igeneral_sequence"
                v-model="igeneral_sequence"
                required="true"
              />
            </div> -->
          </div>
          <div class="p-formgrid p-grid p-mt-3">
            <div class="p-field p-col-12 p-lg-6">
              <label for="igeneral_dataName"
                >{{ $t("igeneral_dataName") }}
                <span class="required-input">*</span></label
              >
              <InputText
                id="igeneral_dataName"
                type="text"
                v-model="igeneral_dataName"
                required="true"
                autofocus
                :class="{
                  'p-invalid': error_igeneral_dataName && !igeneral_dataName,
                }"
              />
              <small
                class="p-invalid"
                v-if="error_igeneral_dataName && !igeneral_dataName"
                >{{ $t("igeneral_dataName_validate") }}</small
              >
            </div>
            <div class="p-field p-col-12 p-lg-3">
              <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                <InputText
                    id="date_create_form"
                    type="text"
                    v-model="date_create_form"
                    autofocus
                    disabled
                />
            </div>
            <div class="p-field p-col-12 p-lg-3">
              <label for="date_update_form">{{
                      $t("imp_update_info_date")
                    }}<span class="required-input"> </span></label>
                <InputText
                    id="date_update_form"
                    type="text"
                    v-model="date_update_form"
                    autofocus
                    disabled
                />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <!-- โหลดเพิ่มแก้ไข 2/8-->
        <Button
          v-if="selectedData != ''"
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          class="p-button-text"
          :disabled="loadingCreate ? true : false"
          @click="clearData()"
        />
        <Button
          v-else
          :label="$t('clearBtn')"
          icon="pi pi-times"
          class="p-button-text"
          :disabled="loadingCreate ? true : false"
          @click="clearData()"
        />
        <Button
          :label="$t('saveBtn')"
          icon="pi pi-check"
          class="p-button-text"
          :disabled="loadingCreate ? true : false"
          @click="saveData()"
        />
        <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
      </template>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete(temp)"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Are you sure for close this modal -->
    <Dialog
      :modal="true"
      :header="$t('ConfirmCloseModal')"
      :visible.sync="displayConfirmationCloseModal"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <span>{{ $t("ConfirmCloseModalSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmationCloseModal = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="closeAllModal()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "system-general",
  components: {
    textFooter,
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      dropdownClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      checkRole:null,
      checkView_data:null,
      checkAdd_data:null,
      checkEdit_data:null,
      checkDelete_data:null,

      keyword: "",
      dataGroupSelect: null,
      systemData_table: [],
      filters: {},
      temp: null,
      displayConfirmation: false,
      systemDataModal: false,

      dataGroupOptions: [],
      igeneral_dataGroupSelect: null,
      disabledMaingroup: 1,
      dataGroupMainOptions: [],
      igeneral_dataGroupMainSelect: null,

      igeneral_sequence: null,
      igeneral_dataName: "",

      error_igeneral_dataName: false,
      error_igeneral_dataGroupSelect: false,

      header: this.$i18n.t("systemData_modal_title_add"),
      selectedData: "",

      check_duplicate: "",
      displayConfirmationCloseModal: false,
      tempFor_displayConfirmationCloseModal: "",

      loading:false,
      // โหลดเพิ่มแก้ไข 3/8
      loadingCreate: false,
      // โหลดเพิ่มแก้ไข 3/8 จบ

      table_BOXmanege:window.innerWidth  > 700 ? 'p-field p-col' : '',
      table_editBTN:window.innerWidth > 700 ? this.$i18n.t('editBtn'):'',
      table_deleteBTN:window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):'',

      table_headerStyle:this.checkInnerWidth('15rem','Column'),
      table_bodyStyle:this.checkInnerWidth('15rem','Body'),
      
      date_create_form:"",
      date_update_form:"",
      // Doe PDF เลือกได้  2/5
      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางข้อมูลพื้นฐานระบบ",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 70,
      PDF_FontHeaderVer:13,
      PDF_FontBodyVer:11,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                    index: {cellWidth: 35},

                    
                    date_update_ddmmyy: {cellWidth: 80},

      },
      
      PDF_minCellWidthHor: 50,
      PDF_FontHeaderHor:15,
      PDF_FontBodyHor:12,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                          index: {cellWidth: 35},

      },
      columns:[
                  {title: "ลำดับ", dataKey: "index" },
                  {title: "กลุ่มข้อมูล", dataKey: "datagroup_name" },
                  {title: "ชื่อข้อมูล", dataKey: "system_name" },
                  {title: "กลุ่มข้อมูลหลัก", dataKey: "maingroup_name"},
                  {title: "วันที่สร้างข้อมูล", dataKey: "date_create_ddmmyy" },
                  {title: "วันที่ปรับปรุงข้อมูล", dataKey: "date_update_ddmmyy" },

              ],

      columnsSelector:null,
      columnsSelectorDialog:null,
      
      displayEditPDF:false,

      columns_index:true,
      columns_datagroup_name:true,
      columns_system_name:true,
      columns_maingroup_name:true,
      columns_road_name:true,
      columns_tambon_name:true,
      columns_amphur_name:true,
      columns_province_name:true,
      columns_event_lat:true,
      columns_event_lon:true,

      columns_date_create: true,
      columns_date_update: true,

      columns_disabled:true,
      // Doe PDF เลือกได้  2/5  จบ

      //  
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"กลุ่มข้อมูล",
          textShow:"",
        },
        {
          DataName:"คำค้นหา",
          textShow:"",
        },
      ],

      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});

                let columns = this.columnsSelector

                const Body_setCenter = ["index"]
                
                const PintPDF = {
                  streak:this.setPDF_Ver,
                  setPosition:this.setPosition_Ver,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeSelect,
                  FileName:this.setnamePDF,
                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderVer,
                  Body_FontSize:this.PDF_FontBodyVer,
                  minCell:this.PDF_minCellWidthVer,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                }
                this.printPDF(PintPDF) 
                
              }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
            let columns = this.columnsSelector

            const Body_setCenter = ["index"]
            const PintPDF = {
              streak:this.setPDF_Hor,
              setPosition:this.setPosition_Hor,
              PDF_Styles:this.setPDF_Styles,
              data:this.$refs.dt.processedData,
              columns:columns,
              columnsStyles:this.PDF_BodySizeHorSelect,
              FileName:this.setnamePDF,
              checkBody_Center:true,
              Body_Center:Body_setCenter,
              Col_FontSize:this.PDF_FontHeaderHor,
              Body_FontSize:this.PDF_FontBodyHor,
              minCell:this.PDF_minCellWidthHor,
              marginPDF:this.setPDF_Margin,
              fillColorPDF:this.setPDF_fillColor,
            }
            this.printPDF(PintPDF) 
            }
          },
        ],
      // Doe : PDF 3/3 จบ
    }
  },
  watch: {
    async systemDataModal(val) {
      if (val == false) {
        if (
          this.tempFor_displayConfirmationCloseModal == "" &&
          this.selectedData == "" &&
          this.igeneral_dataGroupSelect != null &&
          this.igeneral_dataName != ""
        ) {
          // this.displayConfirmationCloseModal = true;
          this.$fire({
                    title: "ยืนยันการปิดหน้าต่างจัดการข้อมูล",
                    text: "คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    
                    if (result.value) {
                     
                      this.systemDataModal = false;
                      this.clearData();
                      
                    }else{
                      this.systemDataModal = true;
                      
                    }
                  })
        } else {
          this.clearData();
          await this.axios
            .post(`${this.$url_service}/get/datagroup`, {
              body: { topic: "get-option-datagroup" },
            })
            .then((response) => {
              (this.dataGroupOptions = response.data.data),
                this.dataGroupOptions.splice(0, 0, {
                  datagroup_id: "getall",
                  datagroup_name: this.$i18n.t("selectAll"),
                });
            });
        }
      } else {
        await this.axios
          .post(`${this.$url_service}/get/datagroup`, {
            body: {
              topic: "get-option-datagroup",
            },
          })
          .then((response) => (this.dataGroupOptions = response.data.data));

          if (this.temp === null) {
            this.date_create_form = this.checkDate_showEN(new Date())
            this.date_update_form = this.checkDate_showEN(new Date())
          }
      }
    },

    displayConfirmationCloseModal(val) {
      if (val == true) {
        this.systemDataModal = true;
      }
    },

    async igeneral_dataGroupSelect(val) {
      if (val == null) {
        this.disabledMaingroup = 1;
        this.igeneral_dataGroupMainSelect = null;
      } else {
        this.igeneral_dataGroupMainSelect = null;
        if (val.datagroup_main == "0") {
          this.disabledMaingroup = 1;
          this.igeneral_dataGroupMainSelect = null;
        } else {
          this.disabledMaingroup = 0;
          if (val.datagroup_id == "dg-11") {
            this.dataGroupMainOptions = [
              { system_id: "vehicle", system_name: this.$i18n.t("vehicle") },
              { system_id: "device", system_name: this.$i18n.t("device") },
            ];
          } else {
            await this.axios
              .post(`${this.$url_service}/get/datagroup`, {
                body: {
                  topic: "get-option-maingroup",
                  datagroup: val.datagroup_id,
                },
              })
              .then((response) => {
                (this.dataGroupMainOptions = response.data.data)
                // ,
                  // console.log(response.data.data);
              });
          }
        }
      }
    },

    async selectedData(val) {
      if (val != "") {
        if (val.datagroup_main == "1") {
          this.disabledMaingroup = 0;
          if (val.datagroup_id == "dg-11") {
            this.igeneral_dataGroupMainSelect = {
              system_id: this.selectedData.maingroup_id,
              system_name: this.$i18n.t(`${this.selectedData.maingroup_id}`),
            };
          } else {
            await this.axios
              .post(`${this.$url_service}/get/datagroup`, {
                body: {
                  topic: "get-option-maingroup",
                  datagroup: this.selectedData.datagroup_id,
                },
              })
              .then(
                (response) => (this.dataGroupMainOptions = response.data.data)
              );
            this.igeneral_dataGroupMainSelect = {
              system_id: this.selectedData.maingroup_id,
              system_name: this.selectedData.maingroup_name,
            };
          }
        } else {
          this.disabledMaingroup = 1;
          this.igeneral_dataGroupMainSelect = null;
        }
      }
    },

    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.systemData_table = []
      }else{
        this.systemData_table = this.cloneTable
      }
    },
    // check_duplicate(val) {
    //   if (val == "duplicate") {
    //     // this.$toast.add({
    //     //   severity: "error",
    //     //   summary: "เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ",
    //     //   detail: "มีข้อมูลนี้ในระบบแล้ว",
    //     //   life: 3000,
    //     // });
    //       this.$fire({
    //           type: "error",
    //           title:"เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ",
    //           text: "มีข้อมูลนี้ในระบบแล้ว",
    //           timer: 3000,
    //           confirmButtonColor: '#28B463',
    //         });
    //   } 
    //   // else {
    //   //   // this.$toast.add({
    //   //   //   severity: "success",
    //   //   //   summary: "เพิ่มข้อมูลสำเร็จ",
    //   //   //   detail: "ข้อมูลพื้นฐานระบบ",
    //   //   //   life: 3000,
    //   //   // });
    //   //     this.$fire({
    //   //         type: "success",
    //   //         title: "เพิ่มข้อมูลสำเร็จ",
    //   //         text: "ข้อมูลพื้นฐานระบบ",
    //   //         timer: 3000,
    //   //         confirmButtonColor: '#28B463',
    //   //       });
    //   // }
    // },

    igeneral_sequence(val) {
      if (val == 0) {
        this.igeneral_sequence = null;
      }
    },
  },
  created() {

    window.addEventListener('resize', this.handleResize);
      this.handleResize();
    
    this.initialData();
    this.checkRole = JSON.parse(localStorage.getItem("data")).permission_id;
    // console.log('this.checkRole =',this.checkRole);

    // Doe PDF เลือกได้  4/5  
    this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      // Doe PDF เลือกได้  4/5  จบ

    this.checkView_data = JSON.parse(localStorage.getItem("data")).view_data;
    this.checkAdd_data = JSON.parse(localStorage.getItem("data")).add_data;
    this.checkEdit_data = JSON.parse(localStorage.getItem("data")).edit_data;
    this.checkDelete_data = JSON.parse(localStorage.getItem("data")).delete_data;

    // console.log(`checkRole = ${this.checkRole} `);
    // console.log(`checkView_data = ${this.checkView_data} `);
    // console.log(`checkAdd_data = ${this.checkAdd_data} `);
    // console.log(`checkEdit_data = ${this.checkEdit_data} `);
    // console.log(`checkDelete_data = ${this.checkDelete_data} `);

    this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)

  },
  destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
  methods: {
    handleResize() {
            // this.window.width = window.innerWidth;
            // this.window.height = window.innerHeight;
            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : ''
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn'):''
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn'):''
            if (window.innerWidth > 700) {
              this.table_headerStyle = this.checkInnerWidth('15rem','Column')
              this.table_bodyStyle = this.checkInnerWidth('15rem','Body')
            }else{
              this.table_headerStyle = this.checkInnerWidth('105px','Column')
              this.table_bodyStyle = this.checkInnerWidth('105px','Body')
            }
            
    },
    exportCSV() {
      debugger;
      this.$refs.dt.exportCSV();
    },

    // Doe ค้นหา  3/6 
    search(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.systemData_table = this.cloneTable.filter((item) => {

          if (item.maingroup_name == null || item.maingroup_name == "null") { 
                item.maingroup_name = "-"
              }

            return (this.columns_datagroup_name ? item.datagroup_name.includes(this.filter) : "") ||
                 (this.columns_system_name ? item.system_name.includes(this.filter) : "") ||
                 (this.columns_maingroup_name ? item.maingroup_name.includes(this.filter) : "") ||
                 (this.columns_date_create
                  ? item.date_create_ddmmyy.includes(this.filter)
                  : "") ||
                 (this.columns_date_update
                  ? item.date_update_ddmmyy.includes(this.filter)
                  : "")

      });

      for (let i = 0; i < this.systemData_table.length; i++) { 
        this.systemData_table[i]["index"] =i+1;
      }

      return (this.systemData_table)

      }else{
        // console.log("5555")
      this.systemData_table = this.cloneTable
      for (let i = 0; i < this.systemData_table.length; i++) { 
        this.systemData_table[i]["index"] =i+1;
      }
      }
      this.systemData_table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async initialData() {
      this.filter='';
      this.cloneTable=[];
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/general/system`, {
          body: { topic: "get-table" },
        })
         // Doe : เพิ่ม ลำดับ 3/4
         .then((response) => {
          this.systemData_table = response.data.data
          // Doe ค้นหา  4/6 
          this.cloneTable = response.data.data
          // Doe ค้นหา  4/6 

          this.formatData(this.systemData_table)
          // console.log("this.systemData_table == id  ",this.systemData_table) 
          
          // Doe ช่องว่างใส่ ขีด
          

        });
        // Doe : เพิ่ม ลำดับ 3/4 จบ

        if (this.columns_disabled == true) {
          this.systemData_table = this.cloneTable
        }else{
          this.systemData_table = []
        }

      await this.axios
        .post(`${this.$url_service}/get/datagroup`, {
          body: {
            topic: "get-option-datagroup",
          },
        })
        .then((response) => {
          (this.dataGroupOptions = response.data.data),
            this.dataGroupOptions.splice(0, 0, {
              datagroup_id: "getall",
              datagroup_name: this.$i18n.t("selectAll"),
            });
        });
        
        this.loading = false;
    },
    formatData(data){
      for (let index = 0; index < data.length; index++) {
            data[index ]["index"] =index +1;

        if (data[index].system_name == null ||
            data[index].system_name == "null" ||
            data[index].system_name == "" ) {
          data[index].system_name = "-"
        }
        if (data[index].maingroup_name == null ||
            data[index].maingroup_name == "null" ||
            data[index].maingroup_name == "" ) {
          data[index].maingroup_name = "-"
        }

        if (data[index].date_create_ddmmyy == null ||
            data[index].date_create_ddmmyy == "null" ||
            data[index].date_create_ddmmyy == "" ) {
          data[index].date_create_ddmmyy = "-";
        }else{
          data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy))
        }

        if (data[index].date_update_ddmmyy == null ||
            data[index].date_update_ddmmyy == "null" ||
            data[index].date_update_ddmmyy == "" ) {
          data[index].date_update_ddmmyy = "-";
        }else{
          data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy))
        }

      }
    },
    closeAllModal() {
      // console.log("Close and don`t save data");
      this.systemDataModal = false;
      this.displayConfirmationCloseModal = false;
      this.clearData();
    },

    async searchSystemData() {
      // this.filter='';
      this.cloneTable=[];
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/general/system`, {
          body: {
            topic: "search-table",
            keyword: this.keyword,
            group_id: this.dataGroupSelect,
          },
        })
        // Doe : เพิ่ม ลำดับ 4/4
        .then((response) => {
          this.systemData_table = response.data.data
          // Doe ค้นหา  5/6 
          this.cloneTable = response.data.data
          // Doe ค้นหา  5/6 

          this.formatData(this.systemData_table)
          // console.log("this.systemData_table == id  ",this.systemData_table)  
          
          this.setSearchText_Footer()
        });
        // Doe : เพิ่ม ลำดับ 4/4 จบ

        if (this.columns_disabled == true) {
          this.systemData_table = this.cloneTable
        }else{
          this.systemData_table = []
        }

        this.search()
        this.loading = false;
    },
    setSearchText_Footer(){
      this.text_Footer=false;
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.dataGroupSelect !== null ||
              this.keyword !== ""  ){
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if (element.DataName === "กลุ่มข้อมูล" && this.dataGroupSelect !== null) {
                  element.textShow = this.dataGroupSelect.datagroup_name
                }
                if (element.DataName === "คำค้นหา" && this.keyword !== "") {
                  element.textShow = this.keyword
                }

              }
              this.text_Footer=true;
          }
    },

    async confirmDelete() {
      this.displayConfirmation = false;
      await this.axios
        .post(
          `${this.$url_service}/general/system?user=${this.getUsername()}`,
          {
            body: {
              topic: "delete-system-data",
              id: this.temp,
            },
          }
        )
        .then(() => 
        // this.initialData()
        this.searchSystemData()
        );
      // this.$toast.add({
      //   severity: "success",
      //   summary: "ลบข้อมูลสำเร็จ",
      //   detail: "ข้อมูลพื้นฐาน",
      //   life: 3000,
      // });
        this.$fire({
              type: "success",
              title:"ลบข้อมูลสำเร็จ",
              text: "ข้อมูลพื้นฐาน",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
    },

    async saveData() {
      //Check null value
      if (
        this.igeneral_dataGroupSelect == null ||
        this.igeneral_dataName == ""
      ) {
        if (this.igeneral_dataGroupSelect == null) {
          this.error_igeneral_dataGroupSelect = true;
        }
        if (this.igeneral_dataName == "") {
          this.error_igeneral_dataName = true;
        }
      } else {
        var sequence;
        if (this.igeneral_sequence == null) {
          sequence = 0;
        } else {
          sequence = this.igeneral_sequence;
        }

        if (this.selectedData == "") {
          // โหลดเพิ่มแก้ไข 4/8
          this.loadingCreate = true;
              // โหลดเพิ่มแก้ไข 4/8 จบ
          await this.axios
            .post(
              `${this.$url_service}/general/system?user=${this.getUsername()}`,
              {
                body: {
                  topic: "add-system-data",
                  datagroup_id: this.igeneral_dataGroupSelect.datagroup_id,
                  maingroup_id: this.igeneral_dataGroupMainSelect,
                  sequence: sequence,
                  dataname: this.igeneral_dataName,
                },
              }
            )
            .then((response) => {
              (this.check_duplicate = response.data.message),
                // this.initialData();
                this.searchSystemData()

                // โหลดเพิ่มแก้ไข 5/8
                this.loadingCreate = false;
                // โหลดเพิ่มแก้ไข 5/8 จบ
                // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                // console.log("this.check_duplicate ",this.check_duplicate)
                if(this.check_duplicate == "duplicate" ){
                  
                  this.$fire({
                    type: "error",
                    title:"เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ",
                    text: "มีข้อมูลนี้ในระบบแล้ว",
                    timer: 3000,
                    confirmButtonColor: '#d33',
                  });
                }else{
                  this.$fire({
                        title: "เพิ่มข้อมูลสำเร็จ",
                        text: "ข้อมูลพื้นฐาน",
                        type: "success",
                        timer: 3000,
                        confirmButtonColor: '#28B463',
                      });
                }
                  
                
                
            });
          // console.log("Save data");
          this.tempFor_displayConfirmationCloseModal = "add";
          this.systemDataModal = false;
        } else {
          // โหลดเพิ่มแก้ไข 6/8 จบ
          this.loadingCreate = true;
                // โหลดเพิ่มแก้ไข 6/8 จบ
          await this.axios
            .post(
              `${this.$url_service}/general/system?user=${this.getUsername()}`,
              {
                body: {
                  topic: "edit-system-data",
                  id: this.temp,
                  datagroup_id: this.igeneral_dataGroupSelect.datagroup_id,
                  maingroup_id: this.igeneral_dataGroupMainSelect,
                  sequence: sequence,
                  dataname: this.igeneral_dataName,
                },
              }
            )
            .then(() => 
            // this.initialData()
            this.searchSystemData()
            );

            // โหลดเพิ่มแก้ไข 7/8 จบ
            this.loadingCreate = false;
                // โหลดเพิ่มแก้ไข 7/8 จบ

          // console.log("Edit data");
          // this.$toast.add({
          //   severity: "success",
          //   summary: "แก้ไขข้อมูลสำเร็จ",
          //   detail: "ข้อมูลพื้นฐาน",
          //   life: 3000,
          // });
            this.$fire({
              type: "success",
              title:"แก้ไขข้อมูลสำเร็จ",
              text: "ข้อมูลพื้นฐาน",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
          this.systemDataModal = false;
        }
      }
    },

    async editData(data) {
      this.header = this.$i18n.t("systemData_modal_title_edit");
      await this.axios
        .post(`${this.$url_service}/general/system`, {
          body: {
            topic: "showone-system-data",
            id: data,
          },
        })
        .then((response) => {
          (this.selectedData = response.data.data),
            (this.igeneral_dataName = response.data.data.system_name),
            (this.igeneral_sequence = Number(response.data.data.system_no)),
            (this.igeneral_dataGroupSelect = {
              datagroup_id: response.data.data.datagroup_id,
              datagroup_name: response.data.data.datagroup_name,
            });

            this.date_create_form = response.data.data.date_create_ddmmyy == null ? "-" : response.data.data.date_create_ddmmyy
            this.date_update_form = response.data.data.date_update_ddmmyy == null ? "-" : response.data.data.date_update_ddmmyy
        });
    },

    clearData() {
      this.dropdownClearFilerValue +=1;
      //Edit data
      if (this.selectedData != "") {
        this.temp = null;
        this.header = this.$i18n.t("systemData_modal_title_add");
        this.displayConfirmation = false;
        this.systemDataModal = false;
        this.selectedData = "";
        this.setDefault();
        //Add data
      } else {
        this.temp = null;
        this.displayConfirmation = false;
        this.setDefault();
      }
    },

    setDefault() {
      this.tempFor_displayConfirmationCloseModal = ""; 
      this.igeneral_dataGroupSelect = null;
      this.igeneral_dataGroupMainSelect = null;
      this.igeneral_sequence = null;
      this.igeneral_dataName = "";
      this.error_igeneral_dataName = false;
      this.error_igeneral_dataGroupSelect = false;

      this.date_create_form = ""
      this.date_update_form = ""
    },

    async clearSearchField() {
      // await this.axios
      //   .post(`${this.$url_service}/general/system`, {
      //     body: { topic: "get-table" },
      //   })
      //   .then((response) => {(this.systemData_table = response.data.data)
      //     // Doe : เพิ่ม ลำดับ 5/5
      //     for (let i = 0; i < this.systemData_table.length; i++) { 
      //       this.systemData_table[i]["index"] =i+1;
      //     }
      //     // Doe : เพิ่ม ลำดับ 5/5 จบ
      //   });
      this.dataGroupSelect = null;
      this.keyword = "";
      this.text_Footer="";
      this.dropdownClearFilerValue +=1;

      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;

      this.initialData();
      // Doe ค้นหา
      this.filter='';
    },
     // dialog หน้าลบ
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
    // Doe PDF เลือกได้  5/5  
    EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length == 1){

          this.PDF_BodySizeSelect = {}

          this.PDF_BodySizeHorSelect = {}
        }
        
        else {

          this.PDF_BodySizeSelect = this.PDF_BodySize

          this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

        }
        
        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_datagroup_name = false
          this.columns_system_name = false
          this.columns_maingroup_name = false

          this.columns_date_create = false;
          this.columns_date_update = false;

          this.columns_disabled = false

        }else{ 
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          let getData = [];
              
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
              getData.push(this.columnsSelectorDialog[index].dataKey);
          }
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
              const element = this.columnsSelectorDialog[index].dataKey
        

              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "datagroup_name") {
                this.columns_datagroup_name = true 
              }else if(!getData.includes("datagroup_name")){
                
                this.columns_datagroup_name = false
              }

              if (element == "system_name") {
                this.columns_system_name = true 
              }else if(!getData.includes("system_name")){
                
                this.columns_system_name = false
              }

              if (element == "maingroup_name") {
                this.columns_maingroup_name = true 
              }else if(!getData.includes("maingroup_name")){
                
                this.columns_maingroup_name = false
              }
              
              if (element == "date_create_ddmmyy") {
                this.columns_date_create = true;
              } else if (!getData.includes("date_create_ddmmyy")) {
                this.columns_date_create = false;
              }

              if (element == "date_update_ddmmyy") {
                this.columns_date_update = true;
              } else if (!getData.includes("date_update_ddmmyy")) {
                this.columns_date_update = false;
              }

          }

        }

        this.columnsSelector = this.columnsSelectorDialog
        this.displayEditPDF = false
        this.filter = ""
      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },
      // Doe PDF เลือกได้  5/5 จบ

  },
};
</script>

<style scoped>
.table_row{
  text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote{
  font-size: 1.2rem;
  }
  #Create{
    width: 149px;
  }
  #EX{
    width: 149px;
  }
  #PDF{
    width: 149px;
  }
  #TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}

@media screen and (max-width: 430px) {
  #Create{
      width: 50%;
    }
    #EX{
      width: 50%;
    }
    #PDF{
      width: 55%;
    }
    #TABLE_EDIT{
      width: 45%;
    }

}

.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
        100%,
        0% {
            stroke: #75e9f4;
        }
        40% {
            stroke: #0057e7;
        }
        66% {
            stroke: #75e9f4;
        }
        80%,
        90% {
            stroke: #0057e7;
        }
    }
/* โหลดเพิ่มแก้ไข 8/8*/

.From_Loading{
position: absolute;
top:35vh;
left: 42.5%;

z-index: 1000;
}
@media screen and (max-width: 430px) {
  .From_Loading{
    position: absolute;
    top:35vh;
    left: 30%;

    z-index: 1000;
    }
}
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.waveTextAnimated {
    margin-top: 0.6em;
    font-weight: bolder;
    margin-top: .5rem;
    font-size: 1.2rem;
    text-shadow: 1px 2px #78777794;
    text-align: center;
}
.waveTextAnimated span {
  display: inline-block;
  -webkit-animation: wave-text 1s ease-in-out infinite;
          animation: wave-text 1s ease-in-out infinite;
}
.waveTextAnimated span:nth-of-type(1) {
  -webkit-animation-delay: 0s;
          animation-delay: 0s;
}
.waveTextAnimated span:nth-of-type(2) {
  -webkit-animation-delay: 0.1s;
          animation-delay: 0.1s;
}
.waveTextAnimated span:nth-of-type(3) {
  -webkit-animation-delay: 0.2s;
          animation-delay: 0.2s;
}
.waveTextAnimated span:nth-of-type(4) {
  -webkit-animation-delay: 0.3s;
          animation-delay: 0.3s;
}
.waveTextAnimated span:nth-of-type(5) {
  -webkit-animation-delay: 0.4s;
          animation-delay: 0.4s;
}
.waveTextAnimated span:nth-of-type(6) {
  -webkit-animation-delay: 0.5s;
          animation-delay: 0.5s;
}
@-webkit-keyframes wave-text {
  00% {
    transform: translateY(0em);
  }
  60% {
    transform: translateY(-0.3em);
  }
  100% {
    transform: translateY(0em);
  }
}
 
@keyframes wave-text {
  00% {
    transform: translateY(0em);
  }
  60% {
    transform: translateY(-0.3em);
  }
  100% {
    transform: translateY(0em);
  }
}
/* โหลดเพิ่มแก้ไข ข้อมูล 8/8 จบ*/
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">

  :deep(.p-dialog) {
    @media screen and (max-width: 991px) {
      .p-dialog-content{
        overflow-y: auto;
      }
    }
    
  }
  :deep(.p-datatable-wrapper table){
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
  }
  :deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
  }
  :deep(.p-datatable-wrapper){
      max-height: 550px;
      overflow: auto;
  }

  .p-multiselect {
    min-width: 15rem;
  }
  
  .multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
  
    .item {
      display: flex;
      align-items: center;
    }
  
    .item-value {
      padding-left: 10px;
      padding-right: 10px;
      border-radius: 3px;
      display: inline-flex;
      margin-right: 0.5rem;
      background-color: var(--primary-color);
      color: var(--primary-color-text);
    }
  }
  </style>
